const EVENTBASEURL = 'event-api/api/';
const LTBASEURL = 'lt-api/api/';

let baseURL = '',
    imgUrl = '';
baseUrlWeb = '';
syncUrl1 = ''; //渝高测试环境管理端认证中心ip
syncUrl2 = ''; //渝高测试环境应用端认证中心ip
if (process.env.NODE_ENV === 'development') {
    // baseURL = 'http://192.168.206.172:9001/api/'; //开发环境
    // baseURL = 'http://192.168.3.52:8001/api/'; //王明明
    // baseURL = 'http://192.168.250.100:8001/api/'; // 邓文晋
    // baseURL = 'http://192.168.206.172:9001/api/'; //旧服务器
    // baseURL = 'http://192.168.51.82:8001/api/'; // 代建锋
    baseURL = 'http://192.168.206.172:9001/api/'; // 服务器 (新服务器ip 2022-04-27更新)
    baseUrlWeb = 'http://192.168.206.172:9002/api/'; //参建方ip  用于认证中心调用接口
    // syncUrl1 = 'http://192.168.206.172:8810/api/';
    // syncUrl2 = 'http://192.168.206.172:8811/api/';
    imgUrl = 'http://tpcs.cq4oss.ctyunxs.cn';
    fileUrl = 'http://tpcs.cq4oss.ctyunxs.cn'; 
    //   baseURL ='../../api/'; //生产环境
} else if (process.env.VUE_APP_CURRENTMODE === 'preview') {
    baseURL = '../../api/'; //测试
    baseUrlWeb = 'http://192.168.206.172:9002/api/'; //参建方ip  用于认证中心调用接口
    imgUrl = 'http://tpcs.cq4oss.ctyunxs.cn';
    fileUrl = 'http://tpcs.cq4oss.ctyunxs.cn';
    // imgUrl = 'http://192.168.206.172:9001';
    // imgUrl = 'http://222.180.168.215:18080/';
} else if (process.env.NODE_ENV === 'production') {
    baseURL = '../../api/'; //生产环境
    baseUrlWeb = 'http://pcs.gcszh.com.cn/api/'; //生产环境参建方ip  用于认证中心调用接口
    // imgUrl = '../../';
    imgUrl = 'http://pcs.cq4oss.ctyunxs.cn';
    fileUrl = 'http://pcs.cq4oss.ctyunxs.cn';
}

const URL = {
    baseURL: baseURL,
    baseUrlWeb: baseUrlWeb,
    syncUrl1: syncUrl1,
    syncUrl2: syncUrl2,
    imgUrl: imgUrl,
    fileUrl: fileUrl,
    // 登录
    log: {
        login: baseURL + 'user/login', //登录
        logout: baseURL + 'user/logout' //退出登录
    },
    /*************************系统管理*****************************/
    // 菜单管理
    menu: {
        list: baseURL + 'sysMenu/list?', // 获取菜单树
        importOnDutySettingMessage: baseURL + 'sysMenu/tree', // Web/App获取菜单选项
        add: baseURL + 'sysMenu/add', // 添加菜单
        edit: baseURL + 'sysMenu/edit', // 添加菜单
        enable: baseURL + 'sysMenu/enable', // 改变菜单启/禁用状态
        delete: baseURL + 'sysMenu/delete', // 添加菜单
        grantMenu: baseURL + 'saas/grantMenu', // 公司_授权菜单
        ownMenu: baseURL + 'saas/ownMenu' // 获取公司授权信息
    },
    //角色管理
    role: {
        roleBase: baseURL + 'role', // 添加角色/修改角色/角色信息回填/删除
        roleDelete: baseURL + 'role/delete', // 添加角色/修改角色/角色信息回填/删除
        getDeatil: baseURL + 'role/findByCode', //角色信息回填
        searchList: baseURL + 'role/search', //角色列表
        saveFunsTreeDada: baseURL + 'roleFunction/addDatas', //绑定功能树
        undateFunsTreeDada: baseURL + 'roleFunction/updateDatas', //修改绑定功能树
        getBelongFunsList: baseURL + 'roleFunction/search', //获取已绑定功能树
        findConfirmRepeat: baseURL + 'role/findConfirmRepeat' //验证类型名称，类型编码是否重复
    },

    //功能管理
    fun: {
        funSearch: baseURL + 'function/page', // 搜索，获取列表
        updateFunctionSet: baseURL + 'function/updateFunctionSet', //角色信息回填
        addFunctionSet: baseURL + 'function/addFunctionSet', //添加
        delete: baseURL + 'function/deleteFunctionSet', //删除
        listFunctionByCompanyId: baseURL + 'functionCompany/listFunctionByCompanyId', //删除
        companyFunction: baseURL + 'functionCompany/companyFunction', //删除
        deleteFunction: baseURL + 'functionCompany/deleteFunction', //公司里删除功能
        addcomFunctionSet: baseURL + 'functionCompany/addFunctionSet', //公司里面添加功能
        resetPwd: baseURL + 'saas/resetPwd' //公司里面添加功能
    },

    //用户管理
    user: {
        searchList: baseURL + 'user/search', // 搜索，获取列表
        getDeatil: baseURL + 'user/find/', //角色信息回填
        add: baseURL + 'user/add', //添加
        delete: baseURL + 'user/delete/', //delete
        update: baseURL + 'user/update', //编辑修改
        addDatas: baseURL + 'userRole/addDatas', //新增绑定角色
        updateRoleTreeData: baseURL + 'userRole/updateDatas', //修改绑定角色
        saveRole: baseURL + 'userRole/save', //绑定角色
        getBelongRoleList: baseURL + 'userRole/search', //所属角色回填
        listFunctions: baseURL + 'user/listFunctions', //查询功能列表
        fetchUserByRole: baseURL + 'user/fetchUserByRole', //获取角色包含组长的用户
        userAddDatas: baseURL + 'userRole/addDatas', //获取角色包含组长的用户
        userCount: baseURL + 'user/fetchCountUser', //用户统计
        resetPassword: baseURL + 'user/resetPassword', //重置密码
        findConfirmRepeat: baseURL + 'user/findConfirmRepeat', //验同一区域下用户名是否重复
        confirmUserPwd: baseURL + 'user/confirmUserPwd' //验证用户密码是否正确
    },

    //部门管理
    deptManage: {
        deptSearch: baseURL + 'projectDepartment/search', //搜索，获取列表
        getDeptsByAreaId: baseURL + 'projectDepartment/getDeptsByAreaId/', //搜索，获取列表
        deptAdd: baseURL + 'projectDepartment/add', //添加部门
        deptDelete: baseURL + 'projectDepartment/delete/', //删除部门
        changeStatus: baseURL + 'projectDepartment/changeStatus', //禁用启用
        deleteByIds: baseURL + 'projectDepartment/deleteByIds', //批量删除
        deptDetail: baseURL + 'projectDepartment/', //回填
        deptModify: baseURL + 'projectDepartment/modify', //编辑
        exportExcel: baseURL + 'projectDepartment/exportexcel' //导出部门
    },

    company: {
        executeDDL: baseURL + 'saas/executeDDL', //执行DD
        searchList: baseURL + 'saas/search', //列表
        edit: baseURL + 'saas/editCompanyAndTenant', //编辑
        add: baseURL + 'saas/addCompanyAndTenant', //新增
        base: baseURL + 'saas/', //编辑
        delete: baseURL + 'saas/delete', //
        dbChangeCheck: baseURL + 'saas/dbChangeCheck' //
    },
    userManager: {
        countAllUser: baseURL + '/saas/countAllUser', //概况
        exportCompanyUser: baseURL + '/saas/exportCompanyUser', //导出
        searchCompanyUser: baseURL + '/saas/searchCompanyUser', //查询列表
        viewUserDetail: baseURL + '/saas/viewUserDetail', //详情
        search: baseURL + '/saas/search' //列表
    },
    // 问题反馈
    problemFeedback: {
        searchProblemList: baseURL + 'saas/systemProblemList', //问题反馈列表
        getProblemDetails: baseURL + 'saas/systemProblemDetails', //问题反馈详情
        updateProblem: baseURL + 'saas/updateSystemProblem', //问题反馈处理
        deleteProblem: baseURL + 'saas/deleteSystemProblem' //问题删除
    },
    // 同步认证中心数据
    authentication: {
        synchroTenant: baseURL + 'auth/center/tenant/sync', //同步所有租户
        synchroCompany: baseUrlWeb + 'auth/center/company/sync', //同步所有公司
        synchroPeople: baseUrlWeb + 'auth/center/companyUser/sync' //同步所有人员
    }
};

module.exports = URL;
